module.exports = __webpack_public_path__ + "static/assets/4e20ec1cacc5cb80a6c049bb4cae35f8.svg";